
angular.module('ui.simpleModal')
	.directive("modalClose", ModalClose);

ModalClose.$inject = [];

function ModalClose() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: '/app/simpleModal/templates/modal-close.html',
		scope: false,
		link: function (scope, elem, attrs, ctrl) {
			
			
		}
	}
}
